import { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../providers/AuthProvider';
import { fetchMyPatterns } from '../services/myPatterns.service';

export const useMyPatterns = () => {
	const { user } = useContext(AuthContext);
	const [patterns, setPatterns] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	useEffect(() => {
		if (!user) {
			setLoading(false);
			return;
		}

		setLoading(true);
		fetchMyPatterns(user.uid)
			.then((docs) => {
				setPatterns(docs);
				setLoading(false);
			})
			.catch((err) => {
				setError(err.message);
				setLoading(false);
			});
	}, [user]);

	return { patterns, loading, error };
};
